var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { BrandingSettings } from 'packages/company/entities/BrandingSettings';
import { EntityBuilder } from '@decahedron/entity';
import ENV from 'config/env';
var BrandSettingsRepository = /** @class */ (function (_super) {
    __extends(BrandSettingsRepository, _super);
    function BrandSettingsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        _this.url = 'company/:companyId/settings/branding';
        _this.entity = BrandingSettings;
        return _this;
    }
    BrandSettingsRepository.prototype.store = function (companyId, settings) {
        return this.put(this.url, settings, { companyId: "" + companyId });
    };
    BrandSettingsRepository.prototype.getForCompany = function (companyId) {
        var _this = this;
        return this.get(this.url, { companyId: "" + companyId })
            .then(function (response) { return EntityBuilder.buildOne(_this.entity, _this.responseTransformer(response).data); });
    };
    return BrandSettingsRepository;
}(AbstractRepository));
export { BrandSettingsRepository };
